export class BaseDto {

  id: string;

}
